export default __webpack_public_path__ + "static/g2-eac92be9846779f227e8422be6ca39bf.jpg";